import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  get_categorieall,
  get_ingredienti,
  get_ingredientebyid,
  reset_ingrediente,
  get_categorie_ingredienti,
  cambia_stato_ingrediente,
  get_ombrelloni,
  get_ombrellonebyid,
  reset_ombrellone,
  stampa_ombrellone,
} from "../store/actions/ordini";
import Spinner from "../components/Spinner";
import "../style/Portate.css";
import "../style/Buttons.css";
import TableOmbrelloni from "../components/TableOmbrelloni";
import { loading_login } from "../store/actions/login";
import { useState } from "react";

const Ombrelloni = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.ordini.loading);
  const categorieall = useSelector((state) => state.ordini.categorieall);
  const ombrelloni = useSelector((state) => state.ordini.ombrelloni);
  const loading2 = useSelector((state) => state.login.loading);
  const id_ruolo = useSelector((state) => state.login.id_ruolo);

  const totalPage = useSelector((state) => state.ordini.total_page);
  const limit = useSelector((state) => state.ordini.limit);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    async function fetchportate() {
      await dispatch(loading_login(true));
      await dispatch(get_ombrelloni(currentPage, limit));
      await dispatch(loading_login(false));
    }
    fetchportate();
  }, [currentPage]);

  const modifica = async (id) => {
    if (id != 0) {
      await dispatch(get_ombrellonebyid(id));

      navigate(`../ombrellone/${id}`);
    } else {
      await dispatch(reset_ombrellone());
      navigate(`../ombrellone/0`);
    }
  };
  const stampaOmbrellone= async (id) => {
    await dispatch(loading_login(true));
    if (await dispatch(stampa_ombrellone(id))) 
    await dispatch(loading_login(false));
  };
  let itemList = [];
  const inserisciPagine = () => {
    for (let i = 1; i <= totalPage; i++) {
      if (i == currentPage) {
        itemList.push(
          <a
            kei={i}
            href="#fakeLink"
            onClick={() => {
              setCurrentPage(i);
            }}
            className="btn"
          >
            {i}
          </a>
        );
      } else {
        itemList.push(
          <a
            kei={i}
            href="#fakeLink"
            onClick={() => {
              setCurrentPage(i);
            }}
            className="btn purple"
          >
            {i}
          </a>
        );
      }
    }
    return itemList;
  };
  return (
    <div className="container-ordini margin50">
      {id_ruolo == 1 ? (
        <div className="apritavolo">
          <a
            href="#fakeLink"
            onClick={() => modifica(0)}
            className="btn"
          >
            Nuovo Ombrellone
          </a>
        </div>
      ) : null}

      {loading || loading2 ? (
        <Spinner />
      ) : ombrelloni != 0 && totalPage != -1 ? (
        <>
          <div className="contenuto-ordini">
            <TableOmbrelloni
              ombrelloni={ombrelloni}
              modifica={modifica}
              stampa={stampaOmbrellone}
             
            />
          </div>
          <div className="nume-page">
            {totalPage > 0 ? inserisciPagine() : null}
          </div>
        </>
      ) : (
        "Non hai ancora caricato nessun ombrellone"
      )}
    </div>
  );
};

export default Ombrelloni;
